/**
 * 台灣地址選擇器元件
 * 縣市 → 區域 級聯選單，自動帶入郵遞區號
 */
import React, { useEffect, useState } from 'react';
import {
  Grid, FormControl, InputLabel, Select, MenuItem, TextField
} from '@mui/material';
import { getCities, getDistricts, getZipcode } from '../data/taiwanAddressData';

const TaiwanAddressSelector = ({
  city,
  district,
  zipcode,
  address,
  onCityChange,
  onDistrictChange,
  onZipcodeChange,
  onAddressChange,
  required = false,
  disabled = false
}) => {
  const [cities] = useState(getCities());
  const [districts, setDistricts] = useState([]);

  // 當縣市變更時，更新區域列表並重置區域和郵遞區號
  useEffect(() => {
    if (city) {
      const districtList = getDistricts(city);
      setDistricts(districtList);
      // 如果當前區域不在新的區域列表中，則重置
      if (district && !districtList.includes(district)) {
        onDistrictChange('');
        onZipcodeChange('');
      }
    } else {
      setDistricts([]);
    }
  }, [city, district, onDistrictChange, onZipcodeChange]);

  // 當區域變更時，自動更新郵遞區號
  useEffect(() => {
    if (city && district) {
      const zip = getZipcode(city, district);
      if (zip && zip !== zipcode) {
        onZipcodeChange(zip);
      }
    }
  }, [city, district, zipcode, onZipcodeChange]);

  const handleCityChange = (event) => {
    const newCity = event.target.value;
    onCityChange(newCity);
    // 重置區域和郵遞區號
    onDistrictChange('');
    onZipcodeChange('');
  };

  const handleDistrictChange = (event) => {
    const newDistrict = event.target.value;
    onDistrictChange(newDistrict);
    // 自動帶入郵遞區號
    if (city && newDistrict) {
      const zip = getZipcode(city, newDistrict);
      onZipcodeChange(zip);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth required={required} disabled={disabled}>
          <InputLabel>縣市</InputLabel>
          <Select
            value={city || ''}
            label="縣市"
            onChange={handleCityChange}
            MenuProps={{
              PaperProps: {
                style: { maxHeight: 300 }
              }
            }}
          >
            <MenuItem value="">
              <em>請選擇縣市</em>
            </MenuItem>
            {cities.map((c) => (
              <MenuItem key={c} value={c}>{c}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth required={required} disabled={disabled || !city}>
          <InputLabel>區域</InputLabel>
          <Select
            value={district || ''}
            label="區域"
            onChange={handleDistrictChange}
            MenuProps={{
              PaperProps: {
                style: { maxHeight: 300 }
              }
            }}
          >
            <MenuItem value="">
              <em>請選擇區域</em>
            </MenuItem>
            {districts.map((d) => (
              <MenuItem key={d} value={d}>{d}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="郵遞區號"
          value={zipcode || ''}
          onChange={(e) => onZipcodeChange(e.target.value)}
          disabled={disabled}
          InputProps={{
            readOnly: !!(city && district),
            sx: (city && district) ? { bgcolor: '#f5f5f5' } : {}
          }}
          helperText={city && district ? '自動帶入' : ''}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="詳細地址"
          value={address || ''}
          onChange={(e) => onAddressChange(e.target.value)}
          placeholder="請輸入完整地址（路/街、巷、弄、號、樓）"
          required={required}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

export default TaiwanAddressSelector;
